<div *ngIf="loadingSpinner" class="loading-overlay center-loader">
  <p-progressSpinner styleClass="role-spinner" strokeWidth="4" animationDuration="0.8s">
  </p-progressSpinner>
</div>

<div [ngStyle]="{'visibility': showEditor ? 'visible' : 'hidden'}" class="dialog-wrapper">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">{{ roleHeader }}</h2>
    <button type="button" class="dialog-close-btn" (click)="clearFormData(); closeAddRole.emit(true)">
      <em class="pi pi-times"></em>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content">
    <div class="content-wrapper">
      <form [formGroup]="orderForm" class="template-content">

        <!-- Basic Information Section -->
        <div class="section">
          <div class="section-heading">
            Basic Details
          </div>
          <div class="section-content">
            <div class="section-item no-border">
              <div class="section-item-content">

                <!-- Role Name -->
                <div class="neo-input-wrapper">
                  <label for="roleName">Role Name <span class="required">*</span></label>
                  <input pInputText type="text" formControlName="roleName"
                    [ngClass]="{'error': clicked && orderForm.controls['roleName'].errors}"
                    placeholder="Enter role name">
                  <app-handle-error [clicked]="clicked" [control]="orderForm.get('roleName')" name="Role name">
                  </app-handle-error>
                </div>

                <!-- Role Type and Work Mode Grid -->
                <div class="neo-grid neo-grid-cols-2">
                  <div class="neo-input-wrapper">
                    <label for="roleType">Role Type <span class="required">*</span></label>
                    <p-select bigger [options]="roleTypeList" formControlName="roleType" optionLabel="label"
                      optionValue="label" [filter]="true" [filterBy]="'label'" [(ngModel)]="selectedRoleType"
                      [appendTo]="'body'" [ngClass]="{'error': clicked && orderForm.controls['roleType'].errors}"
                      placeholder="Choose a role type">
                    </p-select>
                    <app-handle-error [clicked]="clicked" [control]="orderForm.get('roleType')"
                      name="Role type"></app-handle-error>
                  </div>

                  <div class="neo-input-wrapper">
                    <label for="workMode">Work Mode <span class="required">*</span></label>
                    <p-select bigger [options]="workModeList" formControlName="remoteJob" optionLabel="label"
                      optionValue="label" [(ngModel)]="selectedRemote" [appendTo]="'body'"
                      [ngClass]="{'error': clicked && orderForm.controls['remoteJob'].errors}"
                      placeholder="Choose a work mode">
                    </p-select>
                    <app-handle-error [clicked]="clicked" [control]="orderForm.get('remoteJob')"
                      name="Work Mode"></app-handle-error>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Job Details Section -->
        <div class="section">
          <div class="section-heading">
            Job Details
          </div>
          <div class="section-content">
            <div class="section-item no-border">
              <div class="section-item-content">

                <!-- Description -->
                <div class="neo-input-wrapper">
                  <label for="roleDescription">Role Description <span class="required">*</span></label>
                  <textarea id="description-editor" formControlName="roleDescription"></textarea>
                  <app-handle-error [clicked]="clicked" [minLengthValue]="250"
                    [control]="orderForm.get('roleDescription')" name="Role description"></app-handle-error>
                </div>

                <!-- Attachments -->
                <div class="neo-input-wrapper">
                  <label for="attachment">Attachments</label>
                  <div *ngIf="attachmentName?.length" class="attached-file">
                    <div class="file-info">
                      <i class="pi pi-file-pdf file-icon"></i>
                      <div class="file-details">
                        <span class="file-name">{{ attachmentName }}</span>
                      </div>
                    </div>
                    <button type="button" class="remove-file-btn" (click)="onRemoveMedia(mediaFile[0])">
                      <i class="pi pi-trash"></i>
                    </button>
                  </div>

                  <div class="upload-zone" ngx-dropzone [accept]="'image/JPEG, application/pdf'" [multiple]="false"
                    (change)="onSelectMedia($event)">
                    <ngx-dropzone-label *ngIf="!uploadingFile">
                      <div class="upload-content">
                        <i class="pi pi-cloud-upload upload-icon"></i>
                        <p class="upload-text">Drag & Drop your files here or <span class="choose-link">Choose
                            Files</span></p>
                        <p class="upload-limit">Recommended JPG, PDF Only (Max File Size : 2MB)</p>
                      </div>
                    </ngx-dropzone-label>
                    <ngx-dropzone-label *ngIf="uploadingFile">
                      <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="4"
                        animationDuration=".5s"></p-progressSpinner>
                    </ngx-dropzone-label>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Location Details Sections - Each location as separate section -->
        <div formArrayName="locationInformation">
          <div *ngFor="let item of formData.controls; let i = index" [formGroupName]="i">

            <!-- Location Section -->
            <div class="section">
              <div class="section-heading">
                Location {{ i + 1 }} Details
                <button *ngIf="formData.controls.length > 1" type="button" class="remove-location-btn"
                  (click)="removeItem(i)">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
              <div class="section-content">
                <div class="section-item no-border">
                  <div class="section-item-content">

                    <!-- Country - Full Width -->
                    <div class="neo-input-wrapper">
                      <label for="country">Country <span class="required">*</span></label>
                      <p-select bigger [options]="countries" formControlName="country" optionLabel="label"
                        optionValue="value" [filter]="true" [filterBy]="'label'"
                        (onChange)="onCountryChange($event.value, i)" [appendTo]="'body'"
                        [ngClass]="{'error': clicked && locationInformation.controls[i].get('country')?.errors}"
                        placeholder="Choose a country">
                      </p-select>
                      <app-handle-error [clicked]="clicked" [control]="locationInformation.controls[i].get('country')"
                        name="country"></app-handle-error>
                    </div>

                    <!-- State and City Grid -->
                    <div class="neo-grid neo-grid-cols-2">
                      <div class="neo-input-wrapper">
                        <label for="state">State <span class="required">*</span></label>
                        <p-select bigger [options]="locationOptions[i]?.states || []" formControlName="state"
                          optionLabel="label" optionValue="value" [filter]="true" [filterBy]="'label'"
                          (onChange)="onStateChange($event.value, i)" [appendTo]="'body'"
                          [ngClass]="{'error': clicked && locationInformation.controls[i].get('state')?.errors}"
                          placeholder="Choose a state">
                        </p-select>
                        <app-handle-error [clicked]="clicked" [control]="locationInformation.controls[i].get('state')"
                          name="state"></app-handle-error>
                      </div>

                      <div class="neo-input-wrapper">
                        <label for="city">City <span class="required">*</span></label>
                        <p-select bigger [options]="locationOptions[i]?.cities || []" formControlName="city"
                          optionLabel="label" optionValue="value" [filter]="true" [filterBy]="'label'"
                          [appendTo]="'body'"
                          [ngClass]="{'error': clicked && locationInformation.controls[i].get('city')?.errors}"
                          placeholder="Choose a city">
                        </p-select>
                        <app-handle-error [clicked]="clicked" [control]="locationInformation.controls[i].get('city')"
                          name="city"></app-handle-error>
                      </div>
                    </div>

                    <!-- Business Unit - Full Width -->
                    <div class="neo-input-wrapper">
                      <label for="businessUnit">Business Unit <span class="required">*</span></label>
                      <input pInputText type="text" formControlName="businessUnit"
                        [ngClass]="{'error': clicked && locationInformation.controls[i].get('businessUnit')?.errors}"
                        placeholder="Enter business unit">
                      <app-handle-error [clicked]="clicked"
                        [control]="locationInformation.controls[i].get('businessUnit')" name="Business unit">
                      </app-handle-error>
                    </div>

                    <!-- Openings and Maximum Applicants Grid -->
                    <div class="neo-grid neo-grid-cols-2">
                      <div class="neo-input-wrapper">
                        <label for="openings">Openings</label>
                        <input pInputText type="number" formControlName="openings"
                          placeholder="Enter number of openings">
                      </div>

                      <div class="neo-input-wrapper">
                        <label for="maximumApplicants">Maximum Applicants</label>
                        <input pInputText type="number" formControlName="maximumApplicants"
                          placeholder="Enter maximum applicants">
                      </div>
                    </div>

                    <!-- Diversity Quotas Section -->
                    <div class="diversity-section">
                      <label class="diversity-label">Diversity Quotas</label>
                      <div class="diversity-grid">
                        <div class="diversity-item">
                          <label for="maleDiversity">Male</label>
                          <input pInputText type="number" min="0" max="100" formControlName="maleDiversity"
                            placeholder="0">
                        </div>
                        <div class="diversity-item">
                          <label for="femaleDiversity">Female</label>
                          <input pInputText type="number" min="0" max="100" formControlName="femaleDiversity"
                            placeholder="0">
                        </div>
                        <div class="diversity-item">
                          <label for="otherDiversity">Other</label>
                          <input pInputText type="number" min="0" max="100" formControlName="otherDiversity"
                            placeholder="0">
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Add Location Button -->
        <div class="add-location-wrapper">
          <button pButton label="Add Location" icon="pi pi-plus" class="p-button-text add-location-btn-small"
            (click)="addItem()" type="button">
          </button>
        </div>

      </form>
    </div>
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <button pButton pRipple type="submit" (click)="submitItem()" [loading]="saveBtnLoading"
      [label]="isUpdate ? 'Update' : 'Create'" class="create-btn"></button>
  </div>
</div>

<p-toast></p-toast>